<template>
   <div class="grid">
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
  <!-- <GoogleMap api-key="AIzaSyA62nfiBf_7XngEJxzZxltpRMbJjd2f7Fg" style="width: 100%; height: 500px" :center="center" :zoom="12" > -->
    
  <GoogleMap api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 500px" :center="center" :zoom="7" >
   
          <Marker  :options="{ position: center }">
				  </Marker>
    
   
          <Marker  :options="{ position: center1 }">
				  </Marker>
    
    <MarkerCluster>
        <Marker :options="{ position: marker,title: 'stop',label: marker.stop_name,color:'green',icon:'http://maps.google.com/mapfiles/ms/icons/green-dot.png' }"   v-for="(marker, index) in markers" style="width:5px;height:5px">
		    </Marker>
    </MarkerCluster>
           
    <Polyline   :options="flightPath" />
  </GoogleMap>
  </div>
  </div>
  <div class="col-12">
      <div class="card">
      
        <tabs
    v-model="selectedTab"
  >
  <!-- {{tabs}} -->
    <tab
      class="tab"
      v-for="(tab, i) in tabs"
      :key="`t${i}`"
      :val="tab"
      :label="tab"
      :indicator="true"
    />
  </tabs>
    <tab-panels
    v-model="selectedTab"
    :animate="true"
  >
    <tab-panel >
      <!-- {{selected_tab}} -->
      <loading
            :active="isLoadingModel"
            :can-cancel="true"
            
            color="#173EA3"
            :is-full-page="fullPage"
          ></loading>
      <div v-if="selectedTab=='Driver Details'" style="margin-top:20px;height:200px">
        <div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >
        <div class="grid">
            <div class="col-2 md:col-2">
						<img style="width:70px;height:70px;  border-radius: 50%;" :src="(driver_photo?driver_photo:'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=')">
					</div>
					<div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>Driver Name : </span><span style="text-align:right" v-if="driver_name"><b>{{driver_name.toUpperCase()}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Driver Mobile Number : </span><b>{{driver_mobile_number}}</b>
						</div>
            <div class="col-6 md:col-6">
							<span>DL Number : </span><span style="text-align:right" v-if="dl_number"><b>{{dl_number.toUpperCase()}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>DL Expiry Date : </span><b>{{dl_expiry_date}}</b>
						</div>
            
						<div class="col-6 md:col-6">
							<span>Accidental History : </span><b>{{accidental_history}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>Availe 24/7 : </span><b>{{available24by7}}</b>
						</div>
            <div class="col-6 md:col-6">
							<span>Shift time from : </span><b style="">{{shift_time_from}}</b>
						</div>
            <div class="col-6 md:col-6">
							<span>Shift time to : </span><b>{{shift_time_to}}</b>
						</div>
          </div>
          </div>
        </div>

      </div>
      <div  v-if="selectedTab=='Vehicle Details'" style="margin-top:20px;height:200px">
        <div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >
        <div class="grid">
          <div class="col-2 md:col-2">
						<img style="width:70px;height:70px;  border-radius: 50%;" :src="(vehicle_image?vehicle_image:'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=')">
					</div>
					<div class="grid col-4 md:col-10">
          <div class="col-6 md:col-6">
							<span>Vehicle Reg No : </span><b>{{vehicle_registration_number}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>Vehicle Model : </span><b>{{vehicle_model}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>Vehicle Type : </span><b>{{vehicle_type}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>Fitness Validity : </span><b>{{dateFormat(fitness_validity)}}</b>
						</div>
							<div class="col-6 md:col-6">
							<span>Insurance Validity : </span><b>{{dateFormat(insurance_validity)}}</b>
						</div>
						<div class="col-6 md:col-6">
							<span>PUC Validity : </span><b>{{dateFormat(puc_validity)}}</b>
						</div>
          </div>
        </div>
        </div>
      </div>
      <div v-if="selectedTab=='Owner Details'" style="margin-top:20px;height:200px">
        <div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >
        <div class="grid">
            <div class="col-2 md:col-2">
						<img style="width:70px;height:70px;  border-radius: 50%;" :src="(owner_photo?owner_photo:'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o=')">
					</div>
					<div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>Owner Name : </span><span style="text-align:right" v-if="owner_name"><b>{{owner_name.toUpperCase()}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Owner Mobile Number : </span><b>{{owner_mobile_number}}</b>
						</div>
						
          </div>
          </div>
        </div>

      </div>
      <div v-if="selectedTab=='Ride Details'" style="margin-top:20px;height:200px">
        <div class="card mb-0" style="color:white;background-color:#173EA3;font-size:12px;line-height:0.9" >
        <div class="grid">
            
					<div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>Owner Name : </span><span style="text-align:right" v-if="owner_name"><b>{{owner_name.toUpperCase()}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Owner Mobile Number : </span><b>{{owner_mobile_number}}</b>
						</div>
						
          </div>
          <div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>Distance : </span><span style="text-align:right" v-if="data['distance']"><b>{{data['distance']}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Rating : </span><b v-if="data['rating']">{{data['rating']}}</b>
						</div>
						
          </div>
          <div class="grid col-4 md:col-10">
						
							<div class="col-6 md:col-6">
							<span>From : </span><b v-if="data['start_point_details'] && data['start_point_details'][0]">{{data['start_point_details'][0].Place.Label}}</b>
						</div>
            <div class="col-6 md:col-6">
							<span>To : </span><span style="text-align:right" v-if="data['end_point_details'] && data['end_point_details'][0]"><b>{{data['end_point_details'][0].Place.Label}}</b></span>
						</div>
						
          </div>
          <div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>Status : </span><span style="text-align:right" v-if="data['status']"><b>{{data['status']}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Total Time : </span><b>{{data['total_time']}}</b>
						</div>
						
          </div>
          <div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>Total Homes : </span><span style="text-align:right"><b>{{total_stops}}</b></span>
						</div>
							<div class="col-6 md:col-6">
							<span>Total Visited Homes: </span><b>{{visited}}</b>
						</div>
						
          </div>
          <div class="grid col-4 md:col-10">
						<div class="col-6 md:col-6">
							<span>User Mobile No : </span><span style="text-align:right" v-if="data['user_mobile_number']"><b>{{data['user_mobile_number']}}</b></span>
						</div>
					</div>
         
          </div>
        </div>

      </div>

    </tab-panel>
  </tab-panels>
  
          
   </div>
  </div>
   </div>
</template>
<script>
import { GoogleMap, Marker,MarkerCluster,InfoWindow,GMapMarker,Polyline } from "vue3-google-map";
import BreadcrumbService from "../service/BreadcrumbService";
import apis from "@/apis";
import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs';
export default {
  data() {
    return {
      total_stops:0,
      visited:0,
      markers: [],
        // center : { lat: 19.077065, lng: 72.998993 },
        // center1 : { lat: 18.990713, lng: 73.116844 },
        center : {},
        center1 : {},
        flightPlanCoordinates : [],
        selectedTab:'Driver Details',
        flightPath : {
         path:[
            // { lat: 19.077065, lng: 72.998993 },
            // { lat: 19.016804, lng: 73.096458 },
            // { lat: 19.0473216, lng: 73.06990459999997 },  
            // { lat: 18.990713, lng: 73.116844 }
         ],
        //path:[],
        
      geodesic: true,
      strokeColor: "blue",
      strokeOpacity: 0.5,
      strokeWeight: 5,
      
    },
    tabs : ['Driver Details','Vehicle Details','Owner Details','Ride Details'],
    driver_name:'',
      driver_photo:'',
      driver_mobile_number:'',
      vehicle_registration_number:'',
      vehicle_model:'',
      vehicle_image:'',
      vehicle_type:'',
      fuel_type:'',
      make_year:'',
      fitness_validity:'',
      puc_validity:'',
      insurance_validity:'',
      documents:'',
      owner_name:'',
      owner_photo:'',
      owner_mobile_number:'',
      
      dl_number:'',
      dl_expiry_date:'',
      accidental_history:'',
      available24by7:'',
      shift_time_from:'',
      shift_time_to:'',    
    rideData:'',
    data:'',
    list:[],
    BreadcrumbService : null,
    breadcrumbHome: {},
    breadcrumbItems: [],
    }
  },
  methods:
  { 
    getRideGroupStopData(id)
    {
      var data={_id:id};
      var promise = apis.getRideGroupStopData(data);
      promise
        .then(response => {
          if (response.data.data) 
          {
              var stops_data=[];
              this.total_stops= response.data.data.length;
              for (let x = 0; x < response.data.data.length; x++) 
              {   
                stops_data.push({lat: parseFloat(response.data.data[x].stop_location.lat) , lng:parseFloat(response.data.data[x].stop_location.lng),'stop_name':response.data.data[x].stop_name});
                if(response.data.data[x].status=='visited')
                {
                  this.visited=this.visited + 1;
                }
              }
                this.markers=stops_data;
          }
        });
      
    },
    getRideData(id)
    {   
      
      var data={ride_id:id};
      var promise = apis.get_RideData(data);
      promise
        .then(response => {
          this.list=[];
          this.list=response.data;
       
        if (this.list.length>0) 
        {
          var length=this.list.length;
          //1) start point
          this.center={lat:parseFloat(this.list[0].lat) , lng:parseFloat(this.list[0].lng)};
          //2)end point
          this.center1={lat:parseFloat(this.list[length-1].lat) , lng:parseFloat(this.list[length-1].lng)};
          
          //3)poly line
          var data=[];
          for (let x = 0; x < length; x++) 
          { 
            if(this.list[x].lat && this.list[x].lng)
            {
              data.push({lat: parseFloat(this.list[x].lat) , lng:parseFloat(this.list[x].lng)});
            }
            
          }
          this.flightPath = {path:data}

          
         
        }
     
      
      }
      )

    },
   
    dateFormat(inputDate) 
    {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return date+"-"+month+"-"+year;
                }
            }
        }
        else {
           return "";
        }
    }
  },
  created() {
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.ridedetails()
    this.breadcrumbHome=Breadcrum_data.home;
    this.breadcrumbItems=Breadcrum_data.items;
  },
  async mounted() {
    if(localStorage.getItem('ridedetails'))
    {
        // alert('here');
        console.log(localStorage.getItem('ridedetails'));
        this.rideData= JSON.parse(localStorage.getItem('ridedetails'));
        this.data= JSON.parse(localStorage.getItem('ridedetails'));
        await this.getRideData(this.data._id);
        

       
        if(localStorage.getItem("client_id") && localStorage.getItem("client_id")== '6476df2e52c4b674c64b533a')
        { 
          await this.getRideGroupStopData(this.data._id);
        }
        else
        {
          if (this.data.group_stops) 
          {
            var stops_data=[];
            for (let x = 0; x < this.data.group_stops.length; x++) 
            {   
              stops_data.push({lat: parseFloat(this.data.group_stops[x].location.lat) , lng:parseFloat(this.data.group_stops[x].location.lng),'stop_name':this.data.group_stops[x].stop_name});
            }
              this.markers=stops_data;
          }
        }


        this.driver_photo=this.data.driverdetails['profile_image'];
        this.driver_name=this.data.driverdetails['first_name']+" "+this.data.driverdetails['last_name'];
        
        this.driver_mobile_number=this.data.driverdetails['mobile_number'];
        
        this.driver_mobile_number=this.data.driverdetails['mobile_number'];
        this.dl_number=this.data.driverdetails['dldetails']['dl_number'];
        this.dl_expiry_date=this.data.driverdetails['dldetails']['dl_expiry_date'];
        this.accidental_history=this.data.driverdetails['dldetails']['accidental_history'];
        this.available24by7=this.data.driverdetails['dldetails']['available24by7'];
        this.shift_time_from=this.data.driverdetails['dldetails']['shift_time_from'];
        this.shift_time_to=this.data.driverdetails['dldetails']['shift_time_to'];
        if (this.data.ownerdetails && this.data.ownerdetails['first_name'] && this.data.ownerdetails['last_name']) 
        {
          this.owner_name=this.data.ownerdetails['first_name']+" "+this.data.ownerdetails['last_name'];
          this.owner_mobile_number=this.data.ownerdetails['mobile_number'];
          this.owner_photo=this.data.ownerdetails['profile_image'];
        }
        
        
        
        
        this.vehicle_registration_number=this.data.vehicledetails['registration_number'];
        this.vehicle_model=this.data.vehicledetails['model'];
        this.vehicle_type=this.data.vehicledetails['vehicle_type'];
        this.make_year=this.data.vehicledetails['make_year'];
        
        this.fitness_validity=this.data.vehicledetails['fitness_validity'];
        this.insurance_validity=this.data.vehicledetails['insurance_validity'];
        this.puc_validity=this.data.vehicledetails['puc_validity'];
        this.fuel_type=this.data.vehicledetails['fuel_type'];
        if(this.data.vehicledetails['documents'])
        {
          this.vehicle_image=this.data.vehicledetails['documents']['vehicle_photos'][0];
        }
        // alert(this.vehicle_image);
        this.center={lat:this.rideData["start_point"]['latitude'],lng:this.rideData["start_point"]['longitude']};
        this.center1={lat:this.rideData["end_point"]['latitude'],lng:this.rideData["end_point"]['longitude']};
        
      
        //this.getRideData(this.rideData_id);
    }
  },
  components: { Tabs,
    Tab,
    TabPanels,
    TabPanel,GoogleMap, Marker,MarkerCluster,InfoWindow,GMapMarker,Polyline },

}
</script>